export interface MangaCategory {
  slug: string;
  name: string;
  description: string;
}

export const mangaCategories: MangaCategory[] = [
  {
    slug: "love",
    name: "恋爱",
    description: "怦然心动的恋爱故事，甜到齁的浪漫日常",
  },
  {
    slug: "campus",
    name: "校园",
    description: "青涩纯真的校园时光，同桌与操场的故事",
  },
  {
    slug: "city",
    name: "都市",
    description: "都市男女的相遇相知，成年人的心动",
  },
  {
    slug: "comedy",
    name: "搞笑",
    description: "轻松爆笑的日常，笑到停不下来的快乐",
  },
  {
    slug: "sweet",
    name: "甜宠",
    description: "高糖分宠溺剧情，甜宠文漫同步上线",
  },
  {
    slug: "complete",
    name: "完结",
    description: "已完结佳作，一次看完全部章节与大结局",
  },
];

export const getCategoryBySlug = (slug: string): MangaCategory | undefined =>
  mangaCategories.find((c) => c.slug === slug);